require('./fiocUploadBoxes.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { Repeat } = require('immutable');
const { formatText } = require('core/i18n').i18n;
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
// @ constants
const { FIOC_DOCUMENT_CODE_01, FIOC_DOCUMENT_CODE_03, FIOC_DOCUMENT_CODE_10, FIOC_DOCUMENT_CODE_20, BACK_DNI, FRONT_DNI, PASSPORT } = require('constants/index');
const {
    DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT,
    DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE,
    DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME,
    DRAG_N_DROP_UPLOAD_TITLE,
    DRAG_N_DROP_UPLOAD_FILE_TEXT
} = require('constants/commonsComponents');
const MAX_ELEMENTS_PER_ROW = __CONTACT_CENTER__ ? 2 : 3;
// @ helpers
const { getMultiples, getTexts, getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');
const { isDocumentUploadAllowed } = require('utilities/contactCenter/printerHelper');

const DOCUMENT_FRONT = "Front";
const DOCUMENT_BACK = "Back";
class FiocUploadBoxes extends React.Component {
    constructor(props) {
        super(props);
        this.createFronteDorsoError = this.createFronteDorsoError.bind(this);
    }
    getModalLink(name) {
        return <a href="javascript:void(0)" onClick={() => { this.props.modalOpen(name) }} className={`fioc-drop-boxes-wrapper__valid-receipts ${!this.props.isDesktop} && fioc-drop-boxes-mobile`}><span className="fioc-drop-boxes-wrapper__valid-receipts__icon icon-documento"></span>{formatText('fiocSection-validReceipts')}</a>
    }
    createFronteDorsoError(dragBoxName) {
        const { files, isAttachClicked } = this.props;
        const documentCode = dragBoxName.split("-")[1];
        let docRepeatCount = 0;
        if (files.get(dragBoxName)) {
            return '';
        }
        files.forEach((file, ind) => {
            if (ind.split("-")[1] === documentCode) {
                docRepeatCount++;
            }
        });
        if (docRepeatCount !== 0 && isAttachClicked) {
            return formatText("fiocSection-frenteDorsoError");
        }
    }
    render() {
        const {
            documentList,
            maxSize,
            validTypesFile,
            handleAddChange,
            handleRemoveChange
        } = this.props;

        /*Iteration and creating new Array of Obj: Start*/
        let resultList = [];
        documentList.forEach((item) => {
            if (item.get("estadoDocumento") !== "RN" && item.get("estadoDocumento") !== "RK") {
                return true;
            }

            let numberOfTimes = Number(item.get("numMinImagenes"));
            resultList.push(...Repeat(item, numberOfTimes).toArray());
        });
        /*Iteration and creating new Array of Obj: End*/

        const totleFiles = resultList.length;
        let colClass = "";
        if (totleFiles === 1) {
            colClass = "col-md-12";
        } else if (totleFiles === 2) {
            colClass = "col-md-6";
        } else if (totleFiles > 2) {
            colClass = __CONTACT_CENTER__ ? "col-md-6" : "col-md-4";
        }

        let finalResult = [], rowCount = 0, docRepeatCount = 0;
        do {
            let rowContent;
            rowContent = (
                <div key={rowCount} className="row fioc-drop-boxes-wrapper__row">
                    {resultList.slice(rowCount, rowCount + MAX_ELEMENTS_PER_ROW).map((document, index) => {
                        const documentCode = document.get("codTipoDocumento");
                        let documentName = formatText("fiocSection-documentName" + documentCode);
                        let documentNeeded = "";
                        let frenteDorsoError, imageType = "Single";
                        switch (documentCode) {
                            case FIOC_DOCUMENT_CODE_01:
                                docRepeatCount++;
                                if (docRepeatCount === 1) {
                                    documentNeeded = formatText("fiocSection-documentNeeded" + documentCode + DOCUMENT_FRONT);
                                    imageType = FRONT_DNI;
                                } else {
                                    documentNeeded = formatText("fiocSection-documentNeeded" + documentCode + DOCUMENT_BACK);
                                    docRepeatCount = 0;
                                    imageType = BACK_DNI;
                                }
                                break;
                            case FIOC_DOCUMENT_CODE_03:
                                docRepeatCount++;
                                if (docRepeatCount === 1) {
                                    documentNeeded = formatText("fiocSection-documentNeeded" + documentCode + DOCUMENT_FRONT);
                                    imageType = FRONT_DNI;
                                } else if (docRepeatCount === 2) {
                                    documentNeeded = formatText("fiocSection-documentNeeded" + documentCode + DOCUMENT_BACK);
                                    imageType = BACK_DNI;
                                } else {
                                    documentName = formatText("fiocSection-documentName" + documentCode + "2");
                                    documentNeeded = formatText("fiocSection-documentNeeded" + documentCode + "2");
                                    docRepeatCount = 0;
                                    imageType = PASSPORT;
                                }
                                break;
                            case FIOC_DOCUMENT_CODE_10:
                                documentNeeded = this.getModalLink("ingresos");
                                break;
                            case FIOC_DOCUMENT_CODE_20:
                                documentNeeded = this.getModalLink("domicilio");
                        }
                        const multiples = getMultiples(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
                        const texts = getTexts(DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, maxSize, multiples, validTypesFile);
                        const textDescription = getTextDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
                        const textLinkDescription = getTextLinkDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
                        let dragBoxName = "document-" + documentCode + "-" + imageType;

                        if (documentCode === FIOC_DOCUMENT_CODE_01 || documentCode === FIOC_DOCUMENT_CODE_03) {
                            frenteDorsoError = this.createFronteDorsoError(dragBoxName);
                        }

                        return (
                            <div key={index} className={colClass}>
                                <p className="fioc-drop-boxes-wrapper__doc-name" title={documentName}>{documentName}</p>
                                <p className="fioc-drop-boxes-wrapper__doc-desc">{documentNeeded}</p>
                                {
                                    isDocumentUploadAllowed() &&
                                    <DragNDropUpload
                                        idName={dragBoxName}
                                        debug={false}
                                        onChange={(fileState) => { handleAddChange(fileState) }}
                                        disabled={false}
                                        loading={false}
                                        overwriteFile={true}
                                        onDownload={() => { }}
                                        error={false}
                                        errorMessage={''}
                                        hideFormats={true}
                                        hideSizeLimit={true}
                                        isTrashVisible={true}
                                        handleRemoveFile={(fileState) => { handleRemoveChange(fileState) }}
                                        hideUploadedFileList={true}
                                        isModern={true}
                                        iconClass={"fioc-drop-boxes-wrapper__icon"}
                                        successIconClass={"fioc-drop-boxes-wrapper__icon--success"}
                                        errorIconClass={"fioc-drop-boxes-wrapper__icon--error"}
                                        maxSize={maxSize}
                                        validTypesFile={validTypesFile}
                                        hideShowAttachLink={true}
                                        showFrenteDorsoError={frenteDorsoError}
                                        texts={texts}
                                        title={DRAG_N_DROP_UPLOAD_TITLE}
                                        textDescription={textDescription}
                                        textLinkDescription={textLinkDescription}
                                        fileText={DRAG_N_DROP_UPLOAD_FILE_TEXT}
                                    />
                                }
                            </div>
                        )
                    })}
                </div>
            );

            finalResult.push(rowContent);
            rowCount = rowCount + MAX_ELEMENTS_PER_ROW;
        } while (rowCount < resultList.length);
        return (
            <div className="fioc-drop-boxes-wrapper">
                {finalResult}
            </div>
        );
    }
}

FiocUploadBoxes.propTypes = {
    documentList: PropTypes.object,
    files: PropTypes.object,
    modalOpen: PropTypes.func,
    maxSize: PropTypes.number,
    validTypesFile: PropTypes.array,
    handleAddChange: PropTypes.func,
    handleRemoveChange: PropTypes.func,
    isAttachClicked: PropTypes.bool,
    isDesktop: PropTypes.bool
};

module.exports = FiocUploadBoxes;